import FormText from 'components/form/FormText';
import FormWysiwygEditor from 'components/form/FormWysiwygEditor';
import config from 'config/appConfig';
import type { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import type { SignupOldCompanyFormStateType } from '../SignupOldCompany';

import type { JSX } from 'react';

export function SignupOldMailSection({
  register,
  errors,
  control,
}: {
  register: UseFormRegister<SignupOldCompanyFormStateType>;
  errors: FieldErrors<SignupOldCompanyFormStateType>;
  control: Control<SignupOldCompanyFormStateType>;
}): JSX.Element {
  return (
    <div className="form-group">
      <h3 className="title-section title-md fw-bold">メール配信設定</h3>
      <div className="row form-row flex-md-row justify-content-between">
        <div className="column col-lg-6 col-xl-6 col-left">
          <FormText
            subject="差出人名"
            name="reportMailSenderName"
            placeholder="株式会社サンプル"
            register={register}
            errors={errors}
            required={true}
            maxLength={100}
            requiredMark={true}
          />
          <p className="mt-1">レポートメールの送信元名を変更できます</p>
        </div>
        <div className="column col-lg-6 col-xl-6 col-right">
          <FormText
            subject="送信元メールアドレス"
            name="reportMailSenderAddress"
            placeholder={config.ses.from.address}
            register={register}
            errors={errors}
            maxLength={100}
            requiredMark={true}
            readOnly={true}
          />
          <p className="mt-1">現在のプランでは変更できません</p>
        </div>
      </div>
      <div className="row form-row flex-md-row justify-content-between">
        <div className="column col-lg-6 col-xl-6 col-left">
          <FormText
            subject="返信元メールアドレス"
            name="reportMailReplyAddress"
            placeholder="no-reply@branq.jp"
            format="email"
            register={register}
            errors={errors}
            required={true}
            maxLength={300}
            requiredMark={true}
          />
        </div>
        <div className="column col-lg-6 col-xl-6 col-right"></div>
      </div>
      <div className="row form-row flex-md-row justify-content-between">
        <div className="mt-4 col-left">
          {/* プラン設定前で画像生成数のカウントができないため、toolbarにimageの追加は不可 */}
          <FormWysiwygEditor
            subject="レポートメール末尾"
            name="reportMailSignatureHtml"
            placeholder="メール署名部テキスト"
            errors={errors}
            control={control}
            toolbar={['link']}
            required={true}
            requiredMark={true}
          />
          <p className="mt-1">レポートメール末尾の署名部分のテキストです</p>
        </div>
      </div>
    </div>
  );
}
